/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  Activate2FaEnrolmentPayload,
  ActivateMossAppEnrolmentResponse,
  ActivateSmsEnrolmentResponse,
  ActivateTotpEnrolmentResponse,
  ActivateWebAuthnEnrolmentResponse,
  Create2FaEnrolmentForSSoUserPayload,
  Create2FaEnrolmentPayload,
  CreateMossAppEnrolmentResponse,
  CreateSmsEnrolmentResponse,
  CreateTotpEnrolmentResponse,
  CreateWebAuthnEnrolmentResponse,
  GetChallengePayload,
  GetMossAppChallengeResponse,
  GetSmsChallengeResponse,
  GetTotpChallengeResponse,
  GetUnauthenticatedEnrolmentsRequest,
  GetWebAuthnChallengeResponse,
  LoginAndGetRefreshTokenPayload,
  MakeEnrolmentDefaultRequest,
  MobileAuthEnrolmentDto,
  MossAppEnrolmentDto,
  RevokeEnrolmentRequest,
  RevokeEnrolmentResponse,
  SmsMultiFactorEnrolmentDto,
  TotpMultiFactorEnrolmentDto,
  ValidateSmsChallengeResponse,
  ValidateTotpChallengeResponse,
  ValidateWebAuthnChallengeResponse,
  WebAuthnMultiFactorEnrolmentDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiAuthV3Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-auth-v-3-controller
   * @name LoginAndGetRefreshToken
   * @request POST:/api/v3/validate
   */
  loginAndGetRefreshToken = (data: LoginAndGetRefreshTokenPayload, params: RequestParams = {}) =>
    this.http.request<
      | ValidateSmsChallengeResponse
      | ValidateTotpChallengeResponse
      | ValidateWebAuthnChallengeResponse,
      any
    >({
      path: `/v3/validate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static loginAndGetRefreshTokenPath = '/v3/validate'
  static loginAndGetRefreshTokenMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-v-3-controller
   * @name GetActiveEnrolmentsForUnauthorizedUser
   * @request POST:/api/v3/enrolments
   */
  getActiveEnrolmentsForUnauthorizedUser = (
    data: GetUnauthenticatedEnrolmentsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      (
        | MobileAuthEnrolmentDto
        | MossAppEnrolmentDto
        | SmsMultiFactorEnrolmentDto
        | TotpMultiFactorEnrolmentDto
        | WebAuthnMultiFactorEnrolmentDto
      )[],
      any
    >({
      path: `/v3/enrolments`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getActiveEnrolmentsForUnauthorizedUserPath = '/v3/enrolments'
  static getActiveEnrolmentsForUnauthorizedUserMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-v-3-controller
   * @name Revoke2FaEnrolment
   * @request POST:/api/v3/enrolments/revoke
   */
  revoke2FaEnrolment = (data: RevokeEnrolmentRequest, params: RequestParams = {}) =>
    this.http.request<RevokeEnrolmentResponse, any>({
      path: `/v3/enrolments/revoke`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static revoke2FaEnrolmentPath = '/v3/enrolments/revoke'
  static revoke2FaEnrolmentMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-v-3-controller
   * @name Make2FaEnrolmentDefault
   * @request POST:/api/v3/enrolments/make-default
   */
  make2FaEnrolmentDefault = (data: MakeEnrolmentDefaultRequest, params: RequestParams = {}) =>
    this.http.request<
      (
        | MobileAuthEnrolmentDto
        | MossAppEnrolmentDto
        | SmsMultiFactorEnrolmentDto
        | TotpMultiFactorEnrolmentDto
        | WebAuthnMultiFactorEnrolmentDto
      )[],
      any
    >({
      path: `/v3/enrolments/make-default`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static make2FaEnrolmentDefaultPath = '/v3/enrolments/make-default'
  static make2FaEnrolmentDefaultMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-v-3-controller
   * @name Create2FaEnrolment
   * @request POST:/api/v3/enrolments/enrol
   */
  create2FaEnrolment = (data: Create2FaEnrolmentPayload, params: RequestParams = {}) =>
    this.http.request<
      | CreateMossAppEnrolmentResponse
      | CreateSmsEnrolmentResponse
      | CreateTotpEnrolmentResponse
      | CreateWebAuthnEnrolmentResponse,
      any
    >({
      path: `/v3/enrolments/enrol`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static create2FaEnrolmentPath = '/v3/enrolments/enrol'
  static create2FaEnrolmentMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-v-3-controller
   * @name Create2FaEnrolmentForSSoUser
   * @request POST:/api/v3/enrolments/enrol-for-sso-user
   */
  create2FaEnrolmentForSSoUser = (
    data: Create2FaEnrolmentForSSoUserPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<
      | CreateMossAppEnrolmentResponse
      | CreateSmsEnrolmentResponse
      | CreateTotpEnrolmentResponse
      | CreateWebAuthnEnrolmentResponse,
      any
    >({
      path: `/v3/enrolments/enrol-for-sso-user`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static create2FaEnrolmentForSSoUserPath = '/v3/enrolments/enrol-for-sso-user'
  static create2FaEnrolmentForSSoUserMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-v-3-controller
   * @name Activate2FaEnrolment
   * @request POST:/api/v3/enrolments/activate
   */
  activate2FaEnrolment = (data: Activate2FaEnrolmentPayload, params: RequestParams = {}) =>
    this.http.request<
      | ActivateMossAppEnrolmentResponse
      | ActivateSmsEnrolmentResponse
      | ActivateTotpEnrolmentResponse
      | ActivateWebAuthnEnrolmentResponse,
      any
    >({
      path: `/v3/enrolments/activate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static activate2FaEnrolmentPath = '/v3/enrolments/activate'
  static activate2FaEnrolmentMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-v-3-controller
   * @name GetChallenge
   * @request POST:/api/v3/auth_code
   */
  getChallenge = (data: GetChallengePayload, params: RequestParams = {}) =>
    this.http.request<
      | GetMossAppChallengeResponse
      | GetSmsChallengeResponse
      | GetTotpChallengeResponse
      | GetWebAuthnChallengeResponse,
      any
    >({
      path: `/v3/auth_code`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getChallengePath = '/v3/auth_code'
  static getChallengeMethod = 'POST'
  /**
   * No description
   *
   * @tags api-auth-v-3-controller
   * @name GetActiveEnrolmentsForAuthorizedUser
   * @request GET:/api/v3/enrolments-authenticated
   */
  getActiveEnrolmentsForAuthorizedUser = (params: RequestParams = {}) =>
    this.http.request<
      (
        | MobileAuthEnrolmentDto
        | MossAppEnrolmentDto
        | SmsMultiFactorEnrolmentDto
        | TotpMultiFactorEnrolmentDto
        | WebAuthnMultiFactorEnrolmentDto
      )[],
      any
    >({
      path: `/v3/enrolments-authenticated`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getActiveEnrolmentsForAuthorizedUserPath = '/v3/enrolments-authenticated'
  static getActiveEnrolmentsForAuthorizedUserMethod = 'GET'
}
